import React, { useState } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import { NavLink } from "react-router-dom";
import styles from "./ComponentListItem.module.scss";
import ReactTooltip from "react-tooltip";

interface drawerlisttypes {
	route: string;
	id: string | number;
	title: string;
	icon: React.ReactElement;
	open: Boolean;
	click?: any;
}

const ComponentListItem = ({
	route,
	title,
	id,
	icon,
	open,
	click,
}: drawerlisttypes) => {
	const MuiListItem = withStyles({
		root: {
			display: "flex",
			justifyContent: "flex-start",
			alignItems: "flex-start",
			padding: open ? "1px 0 1px 0px" : "1px 0 1px 0px",
		},
	})(ListItem);

	const [activeNav, setActiveNav] = React.useState(false);

	return (
		<MuiListItem key={id}>
			<NavLink
				to={route}
				key={id}
				// onClick={() => click(id)}
				onClick={() => {}}
				data-for="custom-event"
				data-tip={title}
				data-background-color="#002841"
				data-text-color="#FFFFFF"
				exact={true}
				className={styles.drawerList}
				style={{
					background: activeNav && title === "My Account" ? "#D7E0EB" : "",
					width: activeNav && title === "My Account" ? "100%" : "",
					stroke: "white",
					padding: "8px 22px",
					transition: "all 0.4s ease",
				}}
				activeStyle={{
					width: "100%",
					background: "rgba(39, 174, 96, 0.06)",
					border: "none",
					borderLeft: "4px solid #27ae60",
					borderRadius: "6px",
					color: "#27AE60",
				}}
				activeClassName={styles.color}
			>
				<ListItemIcon key={id}>{icon}</ListItemIcon>
				<ListItemText>
					<div
						style={{ display: open ? "flex" : "none" }}
						className={styles.title}
					>
						{title}
					</div>
				</ListItemText>
				{/* <ReactTooltip id="custom-event" /> */}
			</NavLink>
		</MuiListItem>
	);
};

export default ComponentListItem;
